import { Vertical } from "gls/lib";
import React from "react";
import { useTranslation } from "react-i18next";
import { style } from "typestyle";
import { fontFamily } from "../../styles";
import { Form } from "../Form/Form";
import { FormTextInput } from "../Form/FormTextInput";
import { FormState, FormValidator } from "../Form/types";
import { isMandatory } from "../Form/validators/isMandatoryValidator";

export interface NewPasswordLoginProps {
  onSubmit: (newPassword: string) => void;
}

const passwordsMatch: FormValidator = {
  error: "Passwords do not match",
  isValid: (value, formState) => value === formState.newPassword?.value,
};

export const NewPasswordLogin: React.FC<NewPasswordLoginProps> = ({
  onSubmit,
}) => {
  const { t } = useTranslation();
  const onSubmitHandler = ({ newPassword }: FormState) => {
    onSubmit(newPassword.value);
  };

  return (
    <Vertical
      width={300}
      spacing={15}
      className={style({ fontFamily: fontFamily })}
      data-testid="login-new-password"
    >
      <Form
        title={t("Set a new password")}
        onSubmit={onSubmitHandler}
        submitButtonText={t("Set password")}
      >
        <FormTextInput
          name="newPassword"
          password
          label={t("New password")}
          validators={[isMandatory]}
        />

        <FormTextInput
          name="confirmPassword"
          password
          label={t("Confirm new password")}
          validators={[isMandatory, passwordsMatch]}
        />
      </Form>
    </Vertical>
  );
};
